export default function About() {
  return (
    <section id="about" className="py-16 sm:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-start">
          {/* Text content */}
          <div className="lg:col-span-3">
            <div className="mb-4 sm:mb-6">
              <span className="text-amber-600 text-sm font-semibold uppercase tracking-wider">
                About the Author
              </span>
            </div>

            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-gray-900 leading-tight mb-8 sm:mb-12">
              Meet Forrest<br />
              Jamison, Author<br />
              &amp; Storyteller
            </h2>

            <div className="space-y-6 text-gray-600 text-base sm:text-lg leading-relaxed max-w-xl">
              <p>
                Forrest Jamison is a passionate world traveler and a man of strong Christian faith. His extensive journeys around the globe have exposed him to diverse cultures, people, and spiritual traditions, enriching his understanding of the world and deepening his connection to God. Through his travels, he seeks to inspire others through his writings, encouraging a closer relationship with God and a life rooted in faith and purpose. His experiences abroad often serve as a backdrop for his devotional work, offering readers both spiritual insights and a broader perspective on God's work in the world.
              </p>
            </div>
          </div>

          {/* Photos */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-3">
              {/* Left column - tall photo */}
              <div className="overflow-hidden rounded-2xl" style={{ height: '360px' }}>
                <img
                  src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/1a8dd2438cba0c411c1f41bcbd3c4aa5.jpeg"
                  alt="Forrest Jamison"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Right column - two stacked photos */}
              <div className="flex flex-col gap-3">
                <div className="overflow-hidden rounded-2xl" style={{ height: '174px' }}>
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/2e0b23e56ef2dfb8dc9cfffb92e78c98.jpeg"
                    alt="Forrest Jamison"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="overflow-hidden rounded-2xl" style={{ height: '174px' }}>
                  <img
                    src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/e20d66bcb397dc23d1c15b8f796503dc.jpeg"
                    alt="Forrest Jamison"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
